function Stats() {
  return (
    <div className="trips_wrap full bg-main py-4">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="trips d-flex align-items-center gap-3 pe-xl-5">
              <div className="trips_icons flex-1">
                <span className="square--60 circle bg-transparents">
                  <i className="bi bi-patch-check fs-4 text-light"></i>
                </span>
              </div>
              <div className="trips_detail">
                <h5 className="text-light lh-base mb-0">+30 Años de Experiencia</h5>
                <p className="text-light opacity-75 lh-base m-0">
                  Con más de 30 años de trayectoria, el IUTA se ha consolidado como una
                  Institución de referencia en la educación superior del oriente del país.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="trips d-flex align-items-center gap-3 pe-xl-5">
              <div className="trips_icons flex-1">
                <span className="square--60 circle bg-transparents">
                  <i className="bi bi-person-workspace fs-4 text-light"></i>
                </span>
              </div>
              <div className="trips_detail">
                <h5 className="text-light lh-base mb-0">Modalidad Flexible</h5>
                <p className="text-light opacity-75 lh-base m-0">
                  Estudia de manera presencial o multimodal, desde donde estés, con horarios flexibles y adaptados a tus necesidades.
                </p>
              </div>
            </div>
          </div>

          {/* <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="trips d-flex align-items-center gap-3 pe-xl-5">
              <div className="trips_icons flex-1">
                <span className="square--60 circle bg-transparents">
                  <i className="bi bi-shield-fill-check fs-4 text-light"></i>
                </span>
              </div>
              <div className="trips_detail">
                <h5 className="text-light lh-base mb-0">Gradúate</h5>
                <p className="text-light opacity-75 lh-base m-0">
                  These cases are perfectly simple and easy to distinguish
                </p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Stats;
